// Note: this is in its own file to avoid circular dependencies with '../use-guides'.

import { queryClient } from '@/libs/react-query';
import { MediaProgramMetadata } from '@/utils/media/types';
import omit from 'lodash/omit';
import { programMetadataQueryOptions } from '.';

export function cacheProgramMetadata(
    programs: MediaProgramMetadata[] | undefined,
    circleId: number,
    _queryClient = queryClient
) {
    (programs ?? []).forEach((program) => {
        const key = programMetadataQueryOptions.queryKey({
            programIds: new Set([program.programId]),
            circleId,
        });
        const programWithoutGuides = omit(program, 'guides');
        _queryClient.setQueryData<MediaProgramMetadata[]>(key, [
            programWithoutGuides,
        ]);
    });
}
